import { render, staticRenderFns } from "./LunchTableHeader.vue?vue&type=template&id=65fb1bce&scoped=true&"
import script from "./LunchTableHeader.vue?vue&type=script&lang=js&"
export * from "./LunchTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./LunchTableHeader.vue?vue&type=style&index=0&id=65fb1bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb1bce",
  null
  
)

export default component.exports